exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll{position:relative;z-index:100;overflow:hidden}.wrapper p.lead a.gray{color:#535353;text-decoration:underline}\n", ""]);
